import { useEffect, useRef } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, updateDoc, serverTimestamp, arrayUnion } from "firebase/firestore";

function newId() { return (crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()); }

export default function useSessionTracker() {
  const sessionIdRef = useRef(null);
  const startedAtRef  = useRef(Date.now());
  const hbRef = useRef(null);
  const db = getFirestore();
  const auth = getAuth();

  useEffect(() => {
    let unsubAuth = onAuthStateChanged(auth, async (user) => {
      const id = newId();
      sessionIdRef.current = id;

      const meta = {
        userId: user?.uid || 'unauth',
        email: user?.email || null,
        displayName: user?.displayName || null,
        userAgent: navigator.userAgent,
        startedAt: serverTimestamp(),
        lastSeenAt: serverTimestamp(),
        durationSec: 0,
        pages: arrayUnion({ path: window.location.pathname, ts: new Date().toISOString() })
      };

      await setDoc(doc(db, "sessions", id), meta, { merge: true });

      hbRef.current = setInterval(async () => {
        const dur = Math.floor((Date.now() - startedAtRef.current) / 1000);
        await updateDoc(doc(db, "sessions", id), {
          lastSeenAt: serverTimestamp(),
          durationSec: dur
        }).catch(()=>{});
      }, 15000);
    });

    const onPop = async () => {
      const id = sessionIdRef.current; if (!id) return;
      await updateDoc(doc(db, "sessions", id), {
        pages: arrayUnion({ path: window.location.pathname, ts: new Date().toISOString() }),
        lastSeenAt: serverTimestamp()
      }).catch(()=>{});
    };
    window.addEventListener('popstate', onPop);

    const onUnload = async () => {
      const id = sessionIdRef.current; if (!id) return;
      const dur = Math.floor((Date.now() - startedAtRef.current) / 1000);
      try { await navigator.sendBeacon?.('/__noop', new Blob(['x'])); } catch {}
      updateDoc(doc(db, "sessions", id), {
        lastSeenAt: serverTimestamp(),
        durationSec: dur
      }).catch(()=>{});
    };
    window.addEventListener('beforeunload', onUnload);

    return () => {
      if (hbRef.current) clearInterval(hbRef.current);
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('beforeunload', onUnload);
      unsubAuth && unsubAuth();
    };
  }, []);
}
